import React, { useEffect, useLayoutEffect, useState, useRef } from 'react'
import { useWorkStateFields, useStateFields } from '../../store/hooks';
import { useParams } from 'react-router-dom'
import { getAuthToken, globalLoader } from '../../script/util'
import axios from 'axios'
import FaceSearch from '../../components/FaceSearch/FaceSearch'
import Navbar from '../../components/Navbar/Navbar'
import { getCurrentPage } from '../WorkDetail/work_utils'
import * as CONST from '../../script/const'
import WorkDetailHeader from '../WorkDetail/WorkDetailHeader'
import './RegisterSelfie.css'
import CustomStatus from '../../components/CustomStatus/CustomStatus'
import { useNavigate } from 'react-router-dom'
import StoreToken from '../../components/StoreToken'

const RegisterSelfie = () => {
    const [creds, setCreds] = useState(null)
    const [userData, setUserData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [retakeSelfie, setRetakeSelfie] = useState(false)
    const [error, setError] = useState(null)
    const [uploadBlocked, setUploadBlocked] = useState(false)
    const { selfieImage, setSelfieImage } = useWorkStateFields(['selfieImage'])
    const uploadStartedRef = useRef(false)
    const { isLoggedin } = useStateFields(['isLoggedin']);
    const { storeToLocal } = StoreToken();
    const { booking_pk } = useParams()
    const currentPage = getCurrentPage(CONST, CONST.REGISTER_SELFIE);
    const queryParams = new URLSearchParams(window.location.search);
    const isRetakeFlow = queryParams.get('retake') === 'true'
    const subtitle = 'Register your selfie and we’ll notify you as soon as your photos are available.'
    const messageSubtitle = 'We’ll notify you as soon as your photos are available.'
    const navigate = useNavigate()
    const showFaceSearch = (
        (userData && (!userData?.has_selfie || retakeSelfie)) || isRetakeFlow || retakeSelfie
    ) && !error && !uploadBlocked

    useLayoutEffect(() => {
        storeToLocal();
    }, []);

    const getCreds = (upload=false) => {
        const authToken = getAuthToken()
        const headers = {
        Authorization: authToken,
        }
        axios.get(`${process.env.REACT_APP_STAG_URL}/api/booking/selfie-upload/creds/${booking_pk}/`, { headers })
        .then(response => {
            if(response.data.success){
                setCreds(response.data.data)
                upload && uploadSelfie(response.data.data)
            }else{
                setError(response.data)
            }
        })
        .catch(error => {
            if (error.response?.status === 503 && error.response?.data?.disable_s3_activity === true) {
                setUploadBlocked(true)
            } else {
                console.error(error)
            }
        })
    }

    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        const n = bstr.length;
        const u8arr = new Uint8Array(n);
        for (let i = 0; i < n; i++) u8arr[i] = bstr.charCodeAt(i);
        return new Blob([u8arr], { type: mime });
    };

    const updateSelfieStatus = () => {
        const authToken = getAuthToken()
        const headers = {
            Authorization: authToken,
        }
        const data = {
            booking_pk: booking_pk,
        }
        axios.post(`${process.env.REACT_APP_STAG_URL}/api/booking/selfie-upload/update/`, data, { headers })
        .then(response => {
            if(response.data.success){
                queryParams.delete('retake')
                navigate({ search: queryParams.toString()}, { replace: true });
                setSelfieImage(null)
                uploadStartedRef.current = false
                if(response?.data?.past_face_url){
                    navigate(response?.data?.past_face_url)
                } else {
                    getUserData()
                }
            }
        })
        .catch(error => {
            console.error(error)
            setLoading(false)
            uploadStartedRef.current = false
        })
    }

    const getUserData = () => {
        const authToken = getAuthToken()
        const headers = {
            Authorization: authToken,
        }
        setLoading(true)
        axios.get(`${process.env.REACT_APP_STAG_URL}/api/booking/selfie-upload/data/${booking_pk}/`, { headers })
        .then(response => {
            setUserData(response.data)
            setLoading(false)
            if(response.data.has_selfie){
                setRetakeSelfie(false)
            }
        })
        .catch(error => {
            console.error(error)
            setLoading(false)
        })
    }

    const retakeSelfieAction = () => {
        setRetakeSelfie(true)
        setSelfieImage(null)
        uploadStartedRef.current = false
    }

    const cancelRetakeSelfie = () => {
        if (queryParams.get('retake') === 'true') {
            const returnUrl = sessionStorage.getItem('selfieRetakeReturnUrl') || userData?.past_face_url
            sessionStorage.removeItem('selfieRetakeReturnUrl')
            if (returnUrl) {
                navigate(returnUrl)
            }
            return
        }
        setRetakeSelfie(false)
    }

    const uploadSelfie = (awsCreds) => {
        setLoading(true)
        const data = new FormData();
        Object.entries(awsCreds.fields).forEach(([key, value]) => {
            data.append(key, value);
        });
        const fileBlob = dataURLtoBlob(selfieImage);
        data.append("file", fileBlob);
        let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: awsCreds.url,
            data: data,
        };
    
        axios
        .request(config)
        .then(() => {
            updateSelfieStatus()
        })
        .catch(error => {
            console.error(error)
            setLoading(false)
            uploadStartedRef.current = false
        })
    }
    

    useEffect(() => {
        getCreds()
        if (isRetakeFlow) {
            setRetakeSelfie(true)
        } else {
            getUserData()
        }
    }, [])

    useEffect(() => {
        if (!selfieImage) {
            uploadStartedRef.current = false
            return
        }
        if (uploadStartedRef.current) return
        uploadStartedRef.current = true
        if ((!creds || creds?.expires_at <= Date.now())) {
            getCreds(true)
        } else {
            uploadSelfie(creds)
        }
    }, [selfieImage])

    useEffect(() => {
        if (isRetakeFlow) {
            setRetakeSelfie(true)
            return
        }
        if (retakeSelfie) return
        if (userData && userData?.past_face_url) {
            navigate(userData?.past_face_url)
        }
    }, [userData])

    return (
        (isLoggedin && <>
            <Navbar location={"/registerselfie"} title={`Register Selfie`} />
            <WorkDetailHeader currentPage={currentPage} title={`Register Selfie | EventGraphia`} />
            {showFaceSearch && <FaceSearch selfieUpload={true} backNavigation={false} subtitle={subtitle} cancelRetakeSelfie={(isRetakeFlow || retakeSelfie) ? cancelRetakeSelfie : null}/> }
            {!showFaceSearch && userData && userData?.has_selfie && !userData?.past_face_url && !loading &&
                <CustomStatus successMessage="Selfie registered successfully" actionButton={"Retake Selfie"} action={retakeSelfieAction} messageSubtitle={messageSubtitle}/>
            }
            {loading && <div className="overlayLoader">{globalLoader()}</div>}
            {uploadBlocked && !loading && <CustomStatus errorMessage="Photo upload is temporarily unavailable. Please try again later." />}
            {error && <CustomStatus errorMessage={error.message} />}
        </>)
    )
}

export default RegisterSelfie